/**
 * @module FE-CU44_緊急連絡先設定画面_救急情報コンポーネント
 */
export default {
  name: 'AlsokPanel',
  props: {
    marginBottom: {
      type: Number,
      default: 30,
      required: false,
    },
  },
};
